module.exports = __webpack_public_path__ + "files/3a13cf7e59090c72661bfec987a5f894.png";